import React from 'react';
import Header from '../components/Header/Header';
import GrainsHero from '../components/GrainsHero/GrainsHero';
import Services from '../components/Services/Services';
import Footer from '../components/Footer/Footer';
import Coverage from '../components/Coverage/Coverage';
import Regions from '../components/Regions/Regions';
import NewsInsights from '../components/NewsInsights/NewsInsights';
import ReportList from '../components/ReportList/ReportList';

import wheatImg from '../assets/images/grain-wheat.jpg';
import wheatReportImg from '../assets/images/report-cover-wheat.png';
import maizeReportImg from '../assets/images/report-cover-maize.png';
import riceImg from '../assets/images/grain-rice.jpg';
import maizeImg from '../assets/images/grain-maize.jpg';
import barleyImg from '../assets/images/grain-barley.jpg';
import bajraImg from '../assets/images/grain-bajra.jpg';
import FooterCTA from '../components/FooterCTA/FooterCTA';

import wheatSamplePDF from '../assets/samples/wheat-sample.pdf';
import maizeSamplePDF from '../assets/samples/maize-sample.pdf';

// 3. Create the data array to pass to the component
const grainsCoverage = [
  { title: 'Wheat', image: wheatImg },
  { title: 'Rice', image: riceImg },
  { title: 'Maize', image: maizeImg },
  { title: 'Barley', image: barleyImg },
  { title: 'Bajra', image: bajraImg },
];

const grainReports = [
  {
    image: wheatReportImg,
    type: 'Daily Report',
    category: 'GRAINS',
    title: 'Wheat Daily Digest on 07 November 2025',
    index: [
      'Executive Summary',
      'CBOT Wheat (Dec 25) price analysis',
      'MATIF wheat (Dec 25) price analysis',
      'Global wheat trade news and updates'
    ],
    sampleLink: wheatSamplePDF
  },
  {
    image: maizeReportImg,
    type: 'Weekly Update',
    category: 'GRAINS',
    title: 'Maize Weekly Update on 18 August 2025',
    index: [
      'Executive Summary',
      'Maize price trends across major markets',
      'Sowing and harvest progress',
      'Export/Import highlights'
    ],
     sampleLink: maizeSamplePDF
  }
];

const GrainsPage = () => {
  return (
    <>
      <Header />
      <main>
        <GrainsHero />
        <Coverage title="What we cover" items={grainsCoverage} />
        <Services />
        <Regions />
        <NewsInsights />
        <ReportList 
          title="Grains Reports"
          description="In-depth reports on Grains by commodity and region"
          reports={grainReports}
        />
        {/* You can add more grain-specific components here later */}
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default GrainsPage;